app.filter('camelCase', function () {
    return function (input) {
        input = input || '';
        return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };
});

app.filter("trust", ['$sce', function ($sce) {
    return function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };
}]);

app.filter('nospace', function () {
    return function (value) {
        return (!value) ? '' : value.toString().replace(/ /g, '');
    };
});

app.filter('customNumber', function () {
    return function (value) {
        return parseInt(value, 10); //convert to int
    }
});

app.filter('range', function () {
    return function (input, total) {
        total = parseInt(total);
        for (var i = 0; i < total; i++)
            input.push(i);
        return input;
    };
});